import { FC } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ExpandAllIcon from "@mui/icons-material/UnfoldMore";
import CollapseAllIcon from "@mui/icons-material/UnfoldLess";

interface ExpandCollapseButtonProps {
  expanded: boolean;
  onToggle: () => void;
  type: "operations" | "positions" | "aircraft";
}

const ExpandCollapseButton: FC<ExpandCollapseButtonProps> = ({ expanded, onToggle, type }) => {
  const { t } = useTranslation();

  const expandKey =
    type === "operations"
      ? "compliance.expand_all_operations"
      : type === "positions"
        ? "compliance.expand_all_positions"
        : "compliance.expand_all_aircraft";
  const collapseKey =
    type === "operations"
      ? "compliance.collapse_all_operations"
      : type === "positions"
        ? "compliance.collapse_all_positions"
        : "compliance.collapse_all_aircraft";

  const label = expanded ? t(collapseKey) : t(expandKey);

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={onToggle}
      aria-label={label}
      sx={{
        width: { xs: "220px", sm: 40, md: "190px" },
        height: 40,
        minWidth: { xs: 64, sm: 40, md: 64 },
        justifyContent: { xs: "flex-start", sm: "center", md: "flex-start" },
        px: { xs: 2, sm: 1, md: 1 },
      }}
    >
      <Box component="span" sx={{ width: "20px", display: "inline-flex", flexShrink: 0, justifyContent: "center" }}>
        {expanded ? <CollapseAllIcon fontSize="small" /> : <ExpandAllIcon fontSize="small" />}
      </Box>
      <Box component="span" sx={{ ml: 1, display: { xs: "inline", sm: "none", md: "inline" } }}>
        {label}
      </Box>
    </Button>
  );
};

export default ExpandCollapseButton;
